/*
 * cluutch-2026.js
 * Le peu de script que l'identité 2026 demande sur toutes les pages. Chargé en `defer` par
 * layout/theme.liquid, après cluutch-2026.css.
 *
 * Le bandeau d'annonce : Flickity mesure sa lame pendant l'analyse du HTML et fige la hauteur
 * de sa fenêtre en style en ligne ; à ce moment cluutch-2026.css n'est pas toujours appliquée
 * et la police n'est pas chargée (mesuré le 18/09/2026 : 15 px avec la feuille du thème seule,
 * pour 11 attendus). Flickity remesure sur `resize` : on le lui demande une fois les polices
 * prêtes, quand nos feuilles le sont aussi. Auteur : Cluutch / Studio Hogo.
 */
(function () {
  if (window.cluutch2026Ready) return;
  window.cluutch2026Ready = true;

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      window.dispatchEvent(new Event('resize'));
    });
  }
})();
